import {Component, OnInit} from '@angular/core';
import {StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {ElementService} from '../../services/element.service';
import {PortalService} from '../../services/portal.service';
import {HeizcheckAnfrage} from '../anfrage/heizcheck.anfrage';
import {HeizcheckRequestService} from '../services/heizcheck-request.service';
import {EnergyMapComponent} from '../../energy-map/energy.map.component';
import {EnergyMapService} from '../../energy-map/services/energy.map.service';
import {MatDialog} from '@angular/material/dialog';

/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
    selector: 'app-heizcheck-energy-map',
    templateUrl: '../../energy-map/energy.map.component.html',
    standalone: false
})
export class HeizcheckEnergyMapComponent extends EnergyMapComponent implements OnInit{

  /**
   * the users input
   */
  anfrage: HeizcheckAnfrage;

  /**
   *
   * @param stepService
   * @param router
   * @param elementService
   * @param portalService
   * @param requestService
   * @param energyMapService
   * @param dialog
   */
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService,
              protected portalService: PortalService, protected requestService: HeizcheckRequestService,
              protected energyMapService: EnergyMapService, public dialog: MatDialog) {
    super(stepService, router, elementService, portalService, energyMapService, dialog);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.advisorName = 'heizcheck';
    this.anfrage = this.requestService.getAnfrage();
    this.textkeyPrefix = 'heizcheck';

    super.ngOnInit();

    if (this.router.url.endsWith('/heizcheck/heizkostenabrechnung/energy-map')) {
      if(this.anfrage?.heizkostenanalyseInput?.heiznebenkosten_messgeraet_art === 'verdunster') {
        this.lastStep = '/' + this.portalService.currentPortalId + '/heizcheck/heizkostenabrechnung/sonstiges/1';
      }
      else {
        this.lastStep = '/' + this.portalService.currentPortalId + '/heizcheck/heizkostenabrechnung/sonstiges/3';
      }
      this.nextStep = '/' + this.portalService.currentPortalId + '/heizcheck/auswerten/heizkostenabrechnung';
      this.nextStepDonated = '/' + this.portalService.currentPortalId + '/heizcheck/heizkostenabrechnung/energy-map-donated';
    }
    else {
      this.lastStep = '/' + this.portalService.currentPortalId + '/heizcheck/verbrauchsanalyse/verbrauchsdaten';
      this.nextStep = '/' + this.portalService.currentPortalId + '/heizcheck/ergebnis/verbrauchsanalyse';
      this.nextStepDonated = '/' + this.portalService.currentPortalId + '/heizcheck/verbrauchsanalyse/energy-map-donated';
    }
  }
}
